import { Modal } from "antd";
import { Box, Flex, Text, Divider } from "@chakra-ui/react";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import DescricaoCotacao from "./components/DescricaoCotacao";
import TableItensCotados from "./components/TableDetalhesItensCotados/index";
import { useDetalhesItemCotacao } from "core/features/orcamento/hooks/useDetalhesItemCotacao";
import { useLoading } from "components/GlobalLoading/index";

interface ModalDetalhesCotacaoProps {
  isOpenModal: boolean;
  onClose: () => any;
  orcamentoId?: string;
  cotacaoId?: string;
}

function ModalDetalhesCotacao({
  isOpenModal,
  onClose,
  cotacaoId,
  orcamentoId,
}: ModalDetalhesCotacaoProps) {
  const { data, isLoading } = useDetalhesItemCotacao(orcamentoId, cotacaoId);

  useLoading(isLoading);
  return (
    <Modal
      title="Detalhes da cotação"
      centered
      visible={isOpenModal}
      footer={
        <Flex justifyContent="end">
          <PrimaryButton ml={5} mr={2} onClick={onClose}>
            Fechar
          </PrimaryButton>
        </Flex>
      }
      onCancel={onClose}
      destroyOnClose
      width="1200px"
    >
      <Box>
        <DescricaoCotacao item={data} />

        {data?.orcamentoCotacaoItems?.length ? (
          <>
            <Divider my={8} />
            <Text fontSize="20px" fontWeight="medium" mb={4}>
              Itens cotados
            </Text>
            <TableItensCotados data={data?.orcamentoCotacaoItems} />
          </>
        ) : null}
      </Box>
    </Modal>
  );
}

export default ModalDetalhesCotacao;
